<script>
import CheckButton from "@/components/Lego/CheckButton.vue";
import confetti from "canvas-confetti";

export default {
  components: {
    CheckButton,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    lite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      waitGetDone: false,
      previousIsDone: false,
    };
  },
  mounted() {
    if (this.card.id === this.$route.params.cardId) {
      console.log(this.card);
    }
    this.previousIsDone = this.card.isDone;
  },
  computed: {
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
    currencyUserIsResponsible() {
      return this.card.assignments
        .map((a) => a.personaId)
        .includes(this.userLoggedIn.id);
    },
    roleLevel() {
      return this.$store.state.lego.currencyRole.level;
    },
    isDone: {
      get() {
        return this.card.isDone;
      },
      async set() {
        // restricción de role y de si el usuario es responsable
        if (this.roleLevel > 2) {
          if (!this.currencyUserIsResponsible) {
            return;
          }
        }

        if (this.disabled) return;
        const card = {
          id: this.card.id,
          isDone: !this.card.isDone,
          doneBy: this.userLoggedIn.id,
        };
        this.waitGetDone = true;
        await this.$store.dispatch("lego/setIsDoneCard", card);
        this.waitGetDone = false;

        // Activar efecto de confeti si la tarea se completó
        if (card.isDone && !this.previousIsDone) {
          this.launchConfetti();
        }
        this.previousIsDone = card.isDone;
      },
    },
  },
  methods: {
    launchConfetti() {
      const el = this.$el;
      const { left, top, width, height } = el.getBoundingClientRect();
      const x = (left + width / 2) / window.innerWidth;
      const y = (top + height / 2) / window.innerHeight;

      confetti({
        particleCount: 100,
        spread: 70,
        startVelocity: 30,
        angle: 90,
        origin: { x, y },
        disableForReducedMotion: true,
      });
    },
  },
};
</script>

<template>
  <CheckButton
    v-model="isDone"
    :waiting="waitGetDone"
    :lite="lite"
    :disabled="disabled"
  />
</template>
